export default function EditorialMarquee({ dark = false }) {
  const items = ["Crafted For Performance", "8–10 Week Maturation", "Parfum Concentration", "Reserve 30 Parfums"];
  const row = [...items, ...items];
  return (
    <div
      data-testid="editorial-marquee"
      className={`overflow-hidden border-y py-6 md:py-8 ${dark ? "bg-[#111111] text-[#F7F3EE] border-white/10" : "bg-[#F7F3EE] text-[#111111] border-black/10"}`}
    >
      <div className="marquee-track">
        {row.map((t, i) => (
          <span key={`${t}-${i}`} className="flex items-center shrink-0">
            <span className="font-serif-brand italic font-light text-3xl md:text-5xl px-8 whitespace-nowrap">{t}</span>
            <span className="text-[#BA8D53] text-2xl">◆</span>
          </span>
        ))}
      </div>
    </div>
  );
}
